import {DojoTemplates} from './DojoTemplates.js';


// panelWrapper provides a utility class for hiding/showing a tab panel
// and wrapping the element that will be the panel.
class panelWrapper {
	constructor(el) {
		this.el = el;
		this.cacheDisplay = false;
	}
	hide() {
		if (`none`!=this.el.style.display) {
			this.cacheDisplay = this.el.style.display;
		}
		this.el.style.display = `none`;
	}
	show() {
		console.log(`showing panel ${this.title()}, setting display = `, this.cacheDisplay);

		this.el.style.display = this.cacheDisplay ? this.cacheDisplay : "inherit";
		this.cacheDisplay = false;
	}
	title() {
		return this.el.getAttribute(`tab-title`);
	}
	tabId() {
		return this.el.getAttribute(`tab-id`);
	}
}

class tabHeader {
	constructor(tabs, append, wrapper) {
		this.tabs = tabs;
		this.wrapper = wrapper;
		this.span = document.createElement(`span`);
		this.span.innerText = wrapper.title();
		this.span.addEventListener(`click`, (evt)=>{
			evt.preventDefault();
			this.select();
		});
		append(this.span);
		tabs.addEventListener(`dojo-tab-selected`, evt=>{
			if (evt.detail == this.wrapper) {
				this.show();
				this.wrapper.show();
			} else {
				this.hide();
				this.wrapper.hide();
			}
		});
	}
	// hide is called when the panel is hidden
	hide() {
		this.span.classList.remove(`selected`);
	}
	// show is called when the panel is to be shown
	show() {
		this.span.classList.add(`selected`);
	}
	select() {
		this.tabs.dispatchEvent(new CustomEvent(`dojo-tab-selected`, {
			composed: true,
			bubbles: false,
			cancelable: false,
			detail: this.wrapper
		}));		
	}
	setTitle(title) {
		this.span.innerText = title;
	}
	setTitleHTML(titleHtml) {
		this.span.innerHTML = titleHtml;
	}
	tabId() {
		return this.wrapper.tabId();
	}
}


/**
 * DojoTabs provides a tab frame for users to click between tabs on a page.
 */
export class DojoTabs extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = DojoTemplates('DojoTabs');

		this.attachShadow({mode:'open'});
		this.shadowRoot.appendChild(this.el);
		this.tabHeaders = {};
		this.addEventListener(`dojo-tab-title-set`, evt=>{
			let header = this.tabHeaders[evt.detail.tab];
			if (!header) {
				console.error(`No tab header found for id ${evt.detail.tab}`);
			} else {
				header.setTitle(evt.detail.title);
			}
		});
	}
	tabClicked(tab, data, span) {
		// console.log(`TAB clicked: `, tab, span);
	}
	connectedCallback() {
		// when we are constructed, we won't have child elements.
		// SO if we have no child elements, we ask to be re-notified
		// when the DOMContentLoaded event triggers, at which point
		// our child elements will be present.
		if (!this.firstElementChild) {
			document.addEventListener(`DOMContentLoaded`, ()=>this.connectedCallback());
			return;

		}
		let firstTab = null;
		for (let e = this.firstElementChild; e; e=e.nextElementSibling) {
			let header = this.addPanel(e, false, false);
			if (null==firstTab || e.hasAttribute(`selected`)) firstTab = header;
			this.tabHeaders[header.tabId()] = header
		}
		if (firstTab) firstTab.select();
	}
	addPanel(tab, title=false, appendPanel=false) {
		// console.log(`addPanel title=${title}, appendPanel=${appendPanel}`);
		if (!title) title=tab.getAttribute(`tab-title`);
		else tab.setAttribute(`tab-title`, title);
		let wrap = new panelWrapper(tab);
		let header = new tabHeader(this, el=>{
			// console.log(`adding header to tabs: `, el, `, header = `, this.$.header, `, this=`, this);;
			this.$.header.appendChild(el);
		}, wrap);
		if (appendPanel) {
			// console.log(`adding tab to slot`, tab, `, `, this);
			this.appendChild(tab);
		}
		this.tabHeaders[header.tabId()] = header;
		return header;
	}
}
customElements.define('dojo-tabs', DojoTabs);